import requestNoToast from '@/utils/request-no-toast'

export function saveOcrApiLog(data) {
  return requestNoToast({
    url: '/ekycDynaApiLog/saveApiLog',
    method: 'post',
    data
  })
}
